var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","data-cy":"application-wrapper"}},[_c('Translator',{attrs:{"apikey":"AIzaSyAsTfUP_WbDq0clD9R8E3mkZAKKOPLszpw"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }